import { render, staticRenderFns } from "./TheGenre.vue?vue&type=template&id=3ef19945&scoped=true"
import script from "./TheGenre.vue?vue&type=script&lang=ts"
export * from "./TheGenre.vue?vue&type=script&lang=ts"
import style0 from "./TheGenre.vue?vue&type=style&index=0&id=3ef19945&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef19945",
  null
  
)

export default component.exports